/**
 * @file AuthenticationSchemas.ts
 * @description
 * -----------------------------------------------------
 * Schema para Authentication
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-01-14
 * @modified 2025-04-23
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */
import { z } from "zod";

export const LoginSchema = () =>
  z.object({
    mail: z.string().email({ message: "mailInvalid" }),
    password: z
      .string()
      .min(1, "passwordMinLength")
  });

export const RegisterSchema = () =>
  z.object({
    password: z
      .string()
      .min(8, "passwordMinLength")
      .refine((val) => /[a-z]/.test(val), {
        message: "passwordLowerCase",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "passwordUpperCase",
      })
      .refine((val) => /[0-9]/.test(val), {
        message: "passwordDigit",
      })
      .refine((val) => /[[!@#$%^&*()_+{}:;<>,.?/~\-=|]/.test(val), {
        message: "passwordSpecialChar",
      }),
    repeatPassword: z.string().min(8, "repeatPassword"),
  })
  .refine((data) => data.password === data.repeatPassword, {
    message: "repeatPasswordMismatch",
    path: ["repeatPassword"],
  });
